export default __webpack_public_path__ + "static/media/android.788e339b.svg";